export const bigTestDataEnergyMonth = [
  {
    "ReportTimeStamp": "2026-01-06 00:01:11.638261",
    "ReportDate": "2026-01-01",
    "ReportName": "MonthHeatMap",
    "Header": "ReportMessage",
    "CustomerId": null,
    "DeviceId": null,
    "SubReports": {
      "Vantaa": [
        {
          "HwId": "V1",
          "Label": "V Aichelin VKEs kammiouuni 1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 1309,
            "11": 731,
            "12": 446,
            "13": 539,
            "14": 1265,
            "15": 1252,
            "16": 1086,
            "17": 1305,
            "18": 683,
            "19": 968,
            "20": 1255,
            "21": 1074,
            "22": 1318,
            "23": 1100,
            "24": 1076,
            "25": 964,
            "26": 1219,
            "27": 1293,
            "28": 986,
            "01": 1060,
            "02": 862,
            "03": 1358,
            "04": 1073,
            "05": 870,
            "06": 1437,
            "07": 978,
            "08": 1241,
            "09": 1060
          }
        },
        {
          "HwId": "V10",
          "Label": "V Rübig-plasma",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "27": 0,
            "28": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V11",
          "Label": "V B.M.I-alipaineuuni 52",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 1,
            "11": 2,
            "12": 2,
            "13": 1,
            "14": 2,
            "15": 1,
            "16": 2,
            "17": 2,
            "18": 1,
            "19": 2,
            "20": 1,
            "21": 1,
            "22": 2,
            "23": 2,
            "24": 1,
            "25": 2,
            "26": 2,
            "27": 1,
            "28": 2,
            "01": 2,
            "02": 1,
            "03": 2,
            "04": 2,
            "05": 1,
            "06": 2,
            "07": 2,
            "08": 1,
            "09": 2
          }
        },
        {
          "HwId": "V12",
          "Label": "V B.M.I-alipainepäästöuuni 55",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 97,
            "11": 82,
            "12": 152,
            "13": 86,
            "14": 83,
            "15": 114,
            "16": 271,
            "17": 84,
            "18": 84,
            "19": 183,
            "20": 154,
            "21": 177,
            "22": 189,
            "23": 77,
            "24": 83,
            "25": 83,
            "26": 141,
            "27": 229,
            "28": 173,
            "01": 83,
            "02": 83,
            "03": 83,
            "04": 83,
            "05": 83,
            "06": 84,
            "07": 119,
            "08": 279,
            "09": 361
          }
        },
        {
          "HwId": "V13",
          "Label": "V Kuoppanitraus",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 46,
            "11": 47,
            "12": 12,
            "13": 446,
            "14": 595,
            "15": 348,
            "16": 624,
            "17": 625,
            "18": 411,
            "19": 270,
            "20": 491,
            "21": 532,
            "22": 532,
            "23": 417,
            "24": 48,
            "25": 49,
            "26": 13,
            "27": 382,
            "28": 56,
            "01": 48,
            "02": 12,
            "03": 1,
            "04": 1,
            "05": 1,
            "06": 1,
            "07": 522,
            "08": 407,
            "09": 281
          }
        },
        {
          "HwId": "V14",
          "Label": "V B.M.I-jäähdytysjärjestelmä",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "27": 0,
            "28": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V15",
          "Label": "V Päästö/esikuumennusuuni 36",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 50,
            "13": 52,
            "14": 40,
            "15": 56,
            "16": 50,
            "17": 0,
            "18": 0,
            "19": 30,
            "20": 29,
            "21": 28,
            "22": 50,
            "23": 29,
            "24": 0,
            "25": 0,
            "26": 30,
            "27": 36,
            "28": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 41,
            "09": 37
          }
        },
        {
          "HwId": "V16",
          "Label": "V Pesukone 37",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "27": 0,
            "28": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V17",
          "Label": "V Ipsen T2 38",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 386,
            "11": 389,
            "12": 459,
            "13": 468,
            "14": 459,
            "15": 462,
            "16": 435,
            "17": 386,
            "18": 388,
            "19": 458,
            "20": 447,
            "21": 447,
            "22": 459,
            "23": 418,
            "24": 369,
            "25": 370,
            "26": 452,
            "27": 459,
            "28": 441,
            "01": 38,
            "02": 38,
            "03": 39,
            "04": 39,
            "05": 39,
            "06": 38,
            "07": 385,
            "08": 461,
            "09": 421
          }
        },
        {
          "HwId": "V18",
          "Label": "V JK1.1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 162,
            "11": 155,
            "12": 148,
            "13": 142,
            "14": 138,
            "15": 136,
            "16": 127,
            "17": 132,
            "18": 124,
            "19": 118,
            "20": 127,
            "21": 122,
            "22": 135,
            "23": 142,
            "24": 145,
            "25": 146,
            "26": 143,
            "27": 142,
            "28": 150,
            "01": 163,
            "02": 158,
            "03": 161,
            "04": 164,
            "05": 168,
            "06": 164,
            "07": 155,
            "08": 161,
            "09": 163
          }
        },
        {
          "HwId": "V19",
          "Label": "V Etappiallas 39",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "27": 0,
            "28": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V2",
          "Label": "V Aichelin VKEs kammiouuni 2",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 1109,
            "11": 1187,
            "12": 1044,
            "13": 1217,
            "14": 1264,
            "15": 1097,
            "16": 884,
            "17": 1218,
            "18": 1113,
            "19": 1131,
            "20": 1085,
            "21": 1240,
            "22": 1204,
            "23": 1172,
            "24": 973,
            "25": 1075,
            "26": 606,
            "27": 642,
            "28": 661,
            "01": 1198,
            "02": 936,
            "03": 1302,
            "04": 922,
            "05": 1181,
            "06": 1184,
            "07": 1145,
            "08": 968,
            "09": 940
          }
        },
        {
          "HwId": "V20",
          "Label": "V Pesukone 16",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 1,
            "11": 0,
            "12": 1,
            "13": 1,
            "14": 0,
            "15": 0,
            "16": 1,
            "17": 0,
            "20": 0,
            "21": 0,
            "22": 1,
            "23": 1,
            "24": 0,
            "26": 0,
            "27": 0,
            "28": 1,
            "01": 0,
            "02": 1,
            "03": 0,
            "04": 1,
            "05": 0,
            "06": 1,
            "07": 0,
            "08": 1,
            "09": 0
          }
        },
        {
          "HwId": "V21",
          "Label": "V Päästöuuni VKHLE 17",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 211,
            "11": 230,
            "12": 248,
            "13": 256,
            "14": 425,
            "15": 433,
            "16": 330,
            "17": 56,
            "20": 293,
            "21": 462,
            "22": 258,
            "23": 269,
            "24": 0,
            "26": 16,
            "27": 247,
            "28": 216,
            "01": 277,
            "02": 260,
            "03": 276,
            "04": 235,
            "05": 353,
            "06": 289,
            "07": 254,
            "08": 351,
            "09": 338
          }
        },
        {
          "HwId": "V22",
          "Label": "V Alumiiniuuni 25",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "26": 0,
            "27": 0,
            "28": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V23",
          "Label": "V Päästöuuni VKHLE 26",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "26": 0,
            "27": 0,
            "28": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V24",
          "Label": "V Päästöuuni VKHLE 27",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 230,
            "11": 160,
            "12": 162,
            "13": 193,
            "14": 203,
            "15": 214,
            "16": 166,
            "17": 23,
            "20": 100,
            "21": 267,
            "22": 202,
            "23": 237,
            "24": 0,
            "26": 10,
            "27": 159,
            "28": 224,
            "01": 6,
            "02": 5,
            "03": 5,
            "04": 6,
            "05": 5,
            "06": 6,
            "07": 195,
            "08": 109,
            "09": 179
          }
        },
        {
          "HwId": "V25",
          "Label": "V Suojakaasu-uuni 30",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 214,
            "11": 111,
            "12": 108,
            "13": 261,
            "14": 169,
            "15": 269,
            "16": 170,
            "17": 13,
            "20": 166,
            "21": 222,
            "22": 211,
            "23": 162,
            "24": 0,
            "26": 39,
            "27": 203,
            "28": 191,
            "01": 78,
            "02": 73,
            "03": 202,
            "04": 75,
            "05": 140,
            "06": 228,
            "07": 98,
            "08": 190,
            "09": 248
          }
        },
        {
          "HwId": "V26",
          "Label": "V Työkalupäästöuuni 58",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 22,
            "11": 0,
            "12": 36,
            "13": 40,
            "14": 53,
            "15": 53,
            "16": 22,
            "17": 0,
            "20": 21,
            "21": 20,
            "22": 21,
            "23": 22,
            "24": 0,
            "26": 0,
            "27": 30,
            "28": 29,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 17,
            "06": 0,
            "07": 10,
            "08": 39,
            "09": 20
          }
        },
        {
          "HwId": "V27",
          "Label": "V Tuloilman lämmitys",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "27": 0,
            "28": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V28",
          "Label": "V RK1.1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 43,
            "11": 56,
            "12": 81,
            "13": 85,
            "14": 82,
            "15": 89,
            "16": 76,
            "17": 71,
            "18": 75,
            "19": 100,
            "20": 97,
            "21": 81,
            "22": 77,
            "23": 68,
            "24": 67,
            "25": 77,
            "26": 74,
            "27": 70,
            "28": 75,
            "01": 36,
            "02": 55,
            "03": 36,
            "04": 37,
            "05": 65,
            "06": 59,
            "07": 81,
            "08": 78,
            "09": 72
          }
        },
        {
          "HwId": "V3",
          "Label": "V Aichelin VKEs kammiouuni 3",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 1271,
            "11": 1279,
            "12": 1195,
            "13": 1458,
            "14": 1303,
            "15": 1458,
            "16": 1391,
            "17": 1611,
            "18": 1080,
            "19": 1311,
            "20": 1280,
            "21": 1504,
            "22": 1246,
            "23": 1475,
            "24": 1093,
            "25": 1410,
            "26": 1407,
            "27": 1344,
            "28": 1507,
            "01": 514,
            "02": 483,
            "03": 476,
            "04": 474,
            "05": 606,
            "06": 604,
            "07": 1318,
            "08": 1301,
            "09": 1302
          }
        },
        {
          "HwId": "V30",
          "Label": "EMpro MA370",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 3.3178366720676422e-9,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "27": 0,
            "28": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V4",
          "Label": "V Nitrausuuni KREs 20",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 1280,
            "11": 9,
            "12": 891,
            "13": 1406,
            "14": 974,
            "15": 871,
            "16": 1171,
            "17": 1491,
            "18": 295,
            "19": 497,
            "20": 886,
            "21": 11,
            "22": 553,
            "23": 1037,
            "24": 605,
            "25": 9,
            "26": 579,
            "27": 8,
            "28": 859,
            "01": 1047,
            "02": 665,
            "03": 945,
            "04": 8,
            "05": 712,
            "06": 95,
            "07": 742,
            "08": 765,
            "09": 988
          }
        },
        {
          "HwId": "V5",
          "Label": "V Alipainepesukone 21",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 213,
            "11": 220,
            "12": 313,
            "13": 307,
            "14": 259,
            "15": 321,
            "16": 340,
            "17": 235,
            "18": 210,
            "19": 233,
            "20": 271,
            "21": 237,
            "22": 312,
            "23": 299,
            "24": 220,
            "25": 224,
            "26": 256,
            "27": 293,
            "28": 288,
            "01": 230,
            "02": 295,
            "03": 220,
            "04": 231,
            "05": 250,
            "06": 209,
            "07": 298,
            "08": 298,
            "09": 360
          }
        },
        {
          "HwId": "V6",
          "Label": "V Ipsen Kammiopäästö 53",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "27": 0,
            "28": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V7",
          "Label": "V Avoin jäähdytysjärjestelmä",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 16,
            "11": 13,
            "12": 12,
            "13": 16,
            "14": 18,
            "15": 17,
            "16": 18,
            "17": 14,
            "18": 18,
            "19": 15,
            "20": 18,
            "21": 30,
            "22": 16,
            "23": 15,
            "24": 16,
            "25": 15,
            "26": 13,
            "27": 16,
            "28": 15,
            "01": 11,
            "02": 10,
            "03": 12,
            "04": 9,
            "05": 11,
            "06": 12,
            "07": 13,
            "08": 15,
            "09": 16
          }
        },
        {
          "HwId": "V8",
          "Label": "V Päästöuuni VKHLE 28",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 428,
            "11": 318,
            "12": 445,
            "13": 413,
            "14": 532,
            "15": 553,
            "16": 605,
            "17": 351,
            "18": 68,
            "19": 499,
            "20": 376,
            "21": 396,
            "22": 525,
            "23": 318,
            "24": 390,
            "25": 348,
            "26": 418,
            "27": 343,
            "28": 332,
            "01": 100,
            "02": 267,
            "03": 295,
            "04": 294,
            "05": 308,
            "06": 379,
            "07": 328,
            "08": 526,
            "09": 475
          }
        },
        {
          "HwId": "V9",
          "Label": "V Päästöuuni VKHLE 29",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 288,
            "11": 307,
            "12": 443,
            "13": 497,
            "14": 439,
            "15": 422,
            "16": 330,
            "17": 398,
            "18": 354,
            "19": 496,
            "20": 564,
            "21": 500,
            "22": 534,
            "23": 398,
            "24": 402,
            "25": 462,
            "26": 554,
            "27": 506,
            "28": 521,
            "01": 315,
            "02": 423,
            "03": 328,
            "04": 392,
            "05": 434,
            "06": 368,
            "07": 445,
            "08": 365,
            "09": 522
          }
        }
      ],
      "Tampere": [
        {
          "HwId": "T1",
          "Label": "T C230-päästöuuni P6/1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 2,
            "11": 247,
            "12": 344,
            "13": 324,
            "14": 440,
            "15": 1,
            "16": 287,
            "17": 36,
            "18": 4,
            "19": 680,
            "20": 1,
            "21": 289,
            "22": 151,
            "23": 1,
            "24": 1,
            "25": 2,
            "26": 683,
            "27": 42,
            "28": 1,
            "01": 338,
            "02": 293,
            "03": 289,
            "04": 1,
            "05": 147,
            "06": 1,
            "07": 142,
            "08": 571,
            "09": 27
          }
        },
        {
          "HwId": "T10",
          "Label": "T Codere 230-rekuperaattori 1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 330,
            "11": 321,
            "12": 330,
            "13": 332,
            "14": 337,
            "15": 335,
            "16": 329,
            "17": 317,
            "18": 323,
            "19": 315,
            "20": 225,
            "21": 324,
            "22": 325,
            "23": 326,
            "24": 321,
            "25": 321,
            "26": 320,
            "27": 322,
            "28": 317,
            "01": 327,
            "02": 324,
            "03": 328,
            "04": 332,
            "05": 329,
            "06": 333,
            "07": 328,
            "08": 333,
            "09": 337
          }
        },
        {
          "HwId": "T12",
          "Label": "T Kuoppanitrausuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 33,
            "11": 339,
            "12": 97,
            "13": 271,
            "14": 412,
            "15": 325,
            "16": 73,
            "17": 1,
            "18": 2,
            "19": 361,
            "20": 260,
            "21": 407,
            "22": 415,
            "23": 308,
            "24": 106,
            "25": 2,
            "26": 230,
            "27": 328,
            "28": 460,
            "01": 379,
            "02": 95,
            "03": 33,
            "04": 345,
            "05": 96,
            "06": 271,
            "07": 394,
            "08": 387,
            "09": 96
          }
        },
        {
          "HwId": "T13",
          "Label": "T Nitrauksen pesukone",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 102,
            "11": 101,
            "12": 131,
            "13": 107,
            "14": 138,
            "15": 121,
            "16": 102,
            "17": 99,
            "18": 96,
            "19": 146,
            "20": 68,
            "21": 144,
            "22": 110,
            "23": 130,
            "24": 110,
            "25": 110,
            "26": 147,
            "27": 109,
            "28": 143,
            "01": 98,
            "02": 133,
            "03": 96,
            "04": 100,
            "05": 118,
            "06": 97,
            "07": 124,
            "08": 133,
            "09": 141
          }
        },
        {
          "HwId": "T14",
          "Label": "T Codere 250 päästöuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 104,
            "11": 71,
            "12": 190,
            "13": 272,
            "14": 250,
            "15": 194,
            "16": 287,
            "17": 217,
            "18": 241,
            "19": 259,
            "20": 207,
            "21": 203,
            "22": 197,
            "23": 283,
            "24": 218,
            "25": 86,
            "26": 175,
            "27": 164,
            "28": 328,
            "01": 92,
            "02": 157,
            "03": 93,
            "04": 70,
            "05": 261,
            "06": 95,
            "07": 183,
            "08": 158,
            "09": 163
          }
        },
        {
          "HwId": "T15",
          "Label": "T Codere 250 pesukone",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 41,
            "11": 0,
            "12": 145,
            "13": 118,
            "14": 118,
            "15": 123,
            "16": 96,
            "17": 104,
            "18": 120,
            "19": 119,
            "20": 112,
            "21": 139,
            "22": 103,
            "23": 123,
            "24": 129,
            "25": 122,
            "26": 119,
            "27": 124,
            "28": 115,
            "01": 110,
            "02": 106,
            "03": 106,
            "04": 98,
            "05": 126,
            "06": 106,
            "07": 116,
            "08": 104,
            "09": 85
          }
        },
        {
          "HwId": "T16",
          "Label": "T Codere 250 suola-allas",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 482,
            "11": 547,
            "12": 526,
            "13": 524,
            "14": 490,
            "15": 515,
            "16": 3176,
            "17": 1755,
            "18": 1498,
            "19": 1710,
            "20": 485,
            "21": 370,
            "22": 541,
            "23": 557,
            "24": 544,
            "25": 602,
            "26": 538,
            "27": 564,
            "28": 570,
            "01": 560,
            "02": 460,
            "03": 524,
            "04": 538,
            "05": 510,
            "06": 456,
            "07": 477,
            "08": 560,
            "09": 532
          }
        },
        {
          "HwId": "T17",
          "Label": "T Codere 250 rekuperaattori",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 484,
            "11": 290,
            "12": 139,
            "13": 454,
            "14": 485,
            "15": 475,
            "16": 480,
            "17": 486,
            "18": 473,
            "19": 480,
            "20": 481,
            "21": 480,
            "22": 475,
            "23": 473,
            "24": 463,
            "25": 454,
            "26": 481,
            "27": 462,
            "28": 463,
            "01": 450,
            "02": 491,
            "03": 467,
            "04": 505,
            "05": 522,
            "06": 473,
            "07": 463,
            "08": 458,
            "09": 462
          }
        },
        {
          "HwId": "T18",
          "Label": "T Codere 250 C10-uuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 691,
            "11": 683,
            "12": 1157,
            "13": 1321,
            "14": 1275,
            "15": 1133,
            "16": 1160,
            "17": 1354,
            "18": 1287,
            "19": 1272,
            "20": 1103,
            "21": 1203,
            "22": 1174,
            "23": 1231,
            "24": 1084,
            "25": 1015,
            "26": 1160,
            "27": 1119,
            "28": 1240,
            "01": 706,
            "02": 1173,
            "03": 660,
            "04": 679,
            "05": 1336,
            "06": 690,
            "07": 1176,
            "08": 1107,
            "09": 1266
          }
        },
        {
          "HwId": "T19",
          "Label": "T Kompressori (pieni)",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "27": 0,
            "28": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "T2",
          "Label": "T C230-öljypesukone LA2H",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 175,
            "11": 161,
            "12": 186,
            "13": 289,
            "14": 155,
            "15": 205,
            "16": 172,
            "17": 150,
            "18": 114,
            "19": 279,
            "20": 106,
            "21": 181,
            "22": 276,
            "23": 305,
            "24": 212,
            "25": 147,
            "26": 193,
            "27": 144,
            "28": 131,
            "01": 154,
            "02": 199,
            "03": 166,
            "04": 151,
            "05": 194,
            "06": 139,
            "07": 290,
            "08": 164,
            "09": 159
          }
        },
        {
          "HwId": "T20",
          "Label": "T AFC UBT1-päästöuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 279,
            "11": 155,
            "12": 141,
            "13": 168,
            "14": 320,
            "15": 206,
            "16": 324,
            "17": 447,
            "18": 411,
            "19": 282,
            "20": 350,
            "21": 283,
            "22": 530,
            "23": 435,
            "24": 428,
            "25": 297,
            "26": 312,
            "27": 384,
            "28": 530,
            "01": 151,
            "02": 282,
            "03": 324,
            "04": 160,
            "05": 120,
            "06": 120,
            "07": 377,
            "08": 161,
            "09": 269
          }
        },
        {
          "HwId": "T21",
          "Label": "T Schmetz 1-alipaineuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 1530,
            "27": 921,
            "28": 1614,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "T22",
          "Label": "T Carrier (Schmetz)",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 32,
            "12": 0,
            "13": 14,
            "14": 19,
            "15": 212,
            "16": 148,
            "17": 59,
            "18": 35,
            "19": 212,
            "20": 244,
            "21": 235,
            "22": 166,
            "23": 0,
            "24": 0,
            "25": 34,
            "26": 186,
            "27": 239,
            "28": 246,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 188,
            "08": 220,
            "09": 179
          }
        },
        {
          "HwId": "T23",
          "Label": "T Schmetz-jäähdytys",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 105,
            "11": 116,
            "12": 104,
            "13": 107,
            "14": 111,
            "15": 173,
            "16": 168,
            "17": 143,
            "18": 116,
            "19": 189,
            "20": 230,
            "21": 244,
            "22": 211,
            "23": 103,
            "24": 104,
            "25": 115,
            "26": 149,
            "27": 238,
            "28": 136,
            "01": 1,
            "02": 2,
            "03": 1,
            "04": 1,
            "05": 2,
            "06": 1,
            "07": 135,
            "08": 204,
            "09": 195
          }
        },
        {
          "HwId": "T24",
          "Label": "T AFC UBQ2-kammiouuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 25,
            "11": 25,
            "12": 6,
            "13": 0,
            "14": 479,
            "15": 1061,
            "16": 1495,
            "17": 1663,
            "18": 1420,
            "19": 1736,
            "20": 1474,
            "21": 1424,
            "22": 1602,
            "23": 1409,
            "24": 1678,
            "25": 1401,
            "26": 1629,
            "27": 1702,
            "28": 1892,
            "01": 25,
            "02": 24,
            "03": 24,
            "04": 26,
            "05": 26,
            "06": 26,
            "07": 25,
            "08": 26,
            "09": 26
          }
        },
        {
          "HwId": "T25",
          "Label": "T AFC UBT3-päästöuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 489,
            "11": 311,
            "12": 488,
            "13": 684,
            "14": 633,
            "15": 670,
            "16": 703,
            "17": 784,
            "18": 614,
            "19": 759,
            "20": 669,
            "21": 785,
            "22": 615,
            "23": 718,
            "24": 569,
            "25": 440,
            "26": 709,
            "27": 470,
            "28": 802,
            "01": 78,
            "02": 643,
            "03": 610,
            "04": 347,
            "05": 208,
            "06": 84,
            "07": 417,
            "08": 649,
            "09": 712
          }
        },
        {
          "HwId": "T26",
          "Label": "T Schmetz 2-alipaineuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 9,
            "11": 8,
            "12": 8,
            "13": 9,
            "14": 8,
            "15": 1110,
            "16": 929,
            "17": 129,
            "18": 8,
            "19": 1190,
            "20": 1298,
            "21": 1169,
            "22": 800,
            "23": 8,
            "24": 9,
            "25": 8,
            "26": 3,
            "27": 0,
            "28": 0,
            "01": 9,
            "02": 8,
            "03": 8,
            "04": 9,
            "05": 8,
            "06": 8,
            "07": 1276,
            "08": 945,
            "09": 832
          }
        },
        {
          "HwId": "T27",
          "Label": "T Heattec 2 (Sarlin 2-päästö)",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 159,
            "15": 156,
            "16": 138,
            "17": 0,
            "18": 133,
            "19": 17,
            "20": 111,
            "21": 76,
            "22": 115,
            "23": 123,
            "24": 184,
            "25": 175,
            "26": 105,
            "27": 169,
            "28": 218,
            "01": 28,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 170,
            "09": 19
          }
        },
        {
          "HwId": "T28",
          "Label": "T AFC UB2T-päästöuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 127,
            "11": 134,
            "12": 256,
            "13": 252,
            "14": 292,
            "15": 127,
            "16": 311,
            "17": 481,
            "18": 284,
            "19": 478,
            "20": 330,
            "21": 421,
            "22": 360,
            "23": 247,
            "24": 438,
            "25": 171,
            "26": 302,
            "27": 367,
            "28": 477,
            "01": 132,
            "02": 300,
            "03": 135,
            "04": 132,
            "05": 134,
            "06": 135,
            "07": 132,
            "08": 134,
            "09": 257
          }
        },
        {
          "HwId": "T29",
          "Label": "T AFC UBW-pesukone",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "27": 0,
            "28": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "T3",
          "Label": "T C230-hiiletysuuni P10/9",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 3271,
            "11": 1791,
            "12": 3327,
            "13": 1927,
            "14": 2515,
            "15": 1712,
            "16": 1758,
            "17": 3070,
            "18": 1643,
            "19": 3072,
            "20": 1233,
            "21": 2347,
            "22": 1740,
            "23": 1200,
            "24": 3075,
            "25": 1816,
            "26": 2067,
            "27": 793,
            "28": 1237,
            "01": 1772,
            "02": 1855,
            "03": 3209,
            "04": 1762,
            "05": 2667,
            "06": 2779,
            "07": 1829,
            "08": 1577,
            "09": 2751
          }
        },
        {
          "HwId": "T30",
          "Label": "T Heattec 1 (Sarlin 1-päästö)",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 70,
            "13": 0,
            "14": 0,
            "15": 170,
            "16": 151,
            "17": 0,
            "18": 28,
            "19": 0,
            "20": 43,
            "21": 0,
            "22": 50,
            "23": 0,
            "24": 176,
            "25": 19,
            "26": 222,
            "27": 200,
            "28": 168,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 61,
            "05": 111,
            "06": 22,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "T31",
          "Label": "T AFC UBQ1-kammiouuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 1770,
            "11": 1526,
            "12": 1667,
            "13": 1663,
            "14": 1825,
            "15": 1675,
            "16": 1813,
            "17": 1918,
            "18": 1743,
            "19": 1790,
            "20": 1785,
            "21": 1776,
            "22": 1688,
            "23": 1886,
            "24": 1714,
            "25": 943,
            "26": 196,
            "27": 544,
            "28": 1694,
            "01": 747,
            "02": 1633,
            "03": 1771,
            "04": 1505,
            "05": 758,
            "06": 771,
            "07": 1469,
            "08": 1806,
            "09": 1899
          }
        },
        {
          "HwId": "T32",
          "Label": "T Kompressori (suuri)",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 536,
            "11": 513,
            "12": 539,
            "13": 550,
            "14": 552,
            "15": 530,
            "16": 596,
            "17": 610,
            "18": 542,
            "19": 602,
            "20": 634,
            "21": 628,
            "22": 608,
            "23": 536,
            "24": 627,
            "25": 546,
            "26": 587,
            "27": 517,
            "28": 563,
            "01": 475,
            "02": 517,
            "03": 539,
            "04": 494,
            "05": 516,
            "06": 518,
            "07": 536,
            "08": 565,
            "09": 550
          }
        },
        {
          "HwId": "T33",
          "Label": "T Heattec 3",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 536,
            "11": 513,
            "12": 539,
            "13": 550,
            "14": 552,
            "15": 530,
            "16": 595,
            "17": 610,
            "18": 542,
            "19": 602,
            "20": 634,
            "21": 628,
            "22": 608,
            "23": 536,
            "24": 627,
            "25": 546,
            "26": 587,
            "27": 517,
            "28": 563,
            "01": 475,
            "02": 517,
            "03": 539,
            "04": 494,
            "05": 516,
            "06": 518,
            "07": 536,
            "08": 565,
            "09": 550
          }
        },
        {
          "HwId": "T34",
          "Label": "T Aicheling-päästö",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 536,
            "11": 513,
            "12": 539,
            "13": 550,
            "14": 552,
            "15": 530,
            "16": 595,
            "17": 610,
            "18": 542,
            "19": 602,
            "20": 634,
            "21": 628,
            "22": 608,
            "23": 536,
            "24": 627,
            "25": 546,
            "26": 587,
            "27": 517,
            "28": 563,
            "01": 475,
            "02": 517,
            "03": 539,
            "04": 494,
            "05": 516,
            "06": 518,
            "07": 536,
            "08": 565,
            "09": 550
          }
        },
        {
          "HwId": "T4",
          "Label": "T C230-öljyallas H1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 199,
            "11": 245,
            "12": 360,
            "13": 247,
            "14": 293,
            "15": 298,
            "16": 227,
            "17": 116,
            "18": 72,
            "19": 306,
            "20": 47,
            "21": 494,
            "22": 350,
            "23": 224,
            "24": 112,
            "25": 68,
            "26": 578,
            "27": 124,
            "28": 67,
            "01": 238,
            "02": 253,
            "03": 270,
            "04": 85,
            "05": 287,
            "06": 209,
            "07": 276,
            "08": 273,
            "09": 125
          }
        },
        {
          "HwId": "T5",
          "Label": "T C230-hiiletysuuni P10/10",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 1875,
            "11": 2209,
            "12": 1509,
            "13": 2189,
            "14": 2743,
            "15": 1344,
            "16": 1938,
            "17": 2227,
            "18": 452,
            "19": 1606,
            "20": 1312,
            "21": 2281,
            "22": 2085,
            "23": 647,
            "24": 2931,
            "25": 1671,
            "26": 2464,
            "27": 3156,
            "28": 1781,
            "01": 3386,
            "02": 1791,
            "03": 1914,
            "04": 2464,
            "05": 1568,
            "06": 1716,
            "07": 2638,
            "08": 1495,
            "09": 2910
          }
        },
        {
          "HwId": "T6",
          "Label": "T C230-suola-allas S4",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 1266,
            "11": 1260,
            "12": 1276,
            "13": 1243,
            "14": 1064,
            "15": 1321,
            "16": 1308,
            "17": 926,
            "18": 884,
            "19": 1200,
            "20": 883,
            "21": 1313,
            "22": 1314,
            "23": 1419,
            "24": 1244,
            "25": 1188,
            "26": 1351,
            "27": 1094,
            "28": 1188,
            "01": 1206,
            "02": 1269,
            "03": 1090,
            "04": 936,
            "05": 1274,
            "06": 985,
            "07": 1208,
            "08": 1163,
            "09": 1306
          }
        },
        {
          "HwId": "T7",
          "Label": "T C230-suolapesukone LA3S",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 892,
            "11": 831,
            "12": 988,
            "13": 985,
            "14": 918,
            "15": 894,
            "16": 931,
            "17": 833,
            "18": 816,
            "19": 904,
            "20": 642,
            "21": 943,
            "22": 921,
            "23": 928,
            "24": 906,
            "25": 898,
            "26": 959,
            "27": 862,
            "28": 905,
            "01": 782,
            "02": 879,
            "03": 846,
            "04": 837,
            "05": 855,
            "06": 847,
            "07": 874,
            "08": 834,
            "09": 891
          }
        },
        {
          "HwId": "T8",
          "Label": "T C230-päästöuuni P6/7",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 1010,
            "11": 857,
            "12": 1651,
            "13": 846,
            "14": 1384,
            "15": 1036,
            "16": 590,
            "17": 1112,
            "18": 438,
            "19": 1213,
            "20": 928,
            "21": 1468,
            "22": 1167,
            "23": 1801,
            "24": 949,
            "25": 497,
            "26": 1320,
            "27": 1230,
            "28": 1325,
            "01": 683,
            "02": 636,
            "03": 1618,
            "04": 864,
            "05": 676,
            "06": 1039,
            "07": 1090,
            "08": 1167,
            "09": 61
          }
        },
        {
          "HwId": "T9",
          "Label": "T Vesilaitos",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 325,
            "11": 307,
            "12": 297,
            "13": 308,
            "14": 308,
            "15": 290,
            "16": 265,
            "17": 269,
            "18": 264,
            "19": 257,
            "20": 179,
            "21": 255,
            "22": 257,
            "23": 262,
            "24": 273,
            "25": 297,
            "26": 294,
            "27": 299,
            "28": 325,
            "01": 273,
            "02": 304,
            "03": 321,
            "04": 334,
            "05": 338,
            "06": 323,
            "07": 324,
            "08": 317,
            "09": 328
          }
        }
      ],
      "Pieksämäki": [
        {
          "HwId": "P1",
          "Label": "P Ipsen T13",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 715,
            "11": 728,
            "12": 1642,
            "13": 1390,
            "14": 1226,
            "15": 692,
            "16": 73,
            "17": 724,
            "18": 728,
            "19": 727,
            "20": 724,
            "21": 1355,
            "22": 1560,
            "23": 885,
            "24": 713,
            "25": 721,
            "26": 1439,
            "27": 1582,
            "28": 1562,
            "01": 450,
            "02": 777,
            "03": 707,
            "04": 696,
            "05": 698,
            "06": 691,
            "07": 1050,
            "08": 1442,
            "09": 763
          }
        },
        {
          "HwId": "P10",
          "Label": "P Kaminski",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 1431,
            "11": 1131,
            "12": 1421,
            "13": 1013,
            "14": 1143,
            "15": 828,
            "16": 135,
            "17": 1246,
            "18": 1028,
            "19": 714,
            "20": 536,
            "21": 9,
            "22": 7,
            "23": 9,
            "24": 10,
            "25": 15,
            "26": 77,
            "27": 856,
            "28": 1356,
            "01": 795,
            "02": 923,
            "03": 902,
            "04": 996,
            "05": 695,
            "06": 833,
            "07": 926,
            "08": 1432,
            "09": 1054
          }
        },
        {
          "HwId": "P11",
          "Label": "P Sarlin-kammionitrausuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "28": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "P12",
          "Label": "P Nitrauksen pesukone",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 288,
            "11": 250,
            "12": 390,
            "13": 397,
            "14": 381,
            "15": 350,
            "16": 412,
            "17": 232,
            "18": 193,
            "19": 418,
            "20": 395,
            "21": 393,
            "22": 422,
            "23": 413,
            "24": 304,
            "25": 218,
            "26": 332,
            "28": 82,
            "01": 269,
            "02": 325,
            "03": 335,
            "04": 352,
            "05": 345,
            "06": 273,
            "07": 404,
            "08": 441,
            "09": 350
          }
        },
        {
          "HwId": "P13",
          "Label": "P Borel-kuoppauuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 3,
            "11": 3,
            "12": 310,
            "13": 1356,
            "14": 1006,
            "15": 969,
            "16": 770,
            "17": 27,
            "18": 31,
            "19": 988,
            "20": 1005,
            "21": 949,
            "22": 930,
            "23": 690,
            "24": 27,
            "25": 31,
            "26": 1160,
            "28": 5,
            "01": 3,
            "02": 3,
            "03": 4,
            "04": 3,
            "05": 948,
            "06": 153,
            "07": 1314,
            "08": 445,
            "09": 15
          }
        },
        {
          "HwId": "P14",
          "Label": "P Kuoppanitrausuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 422,
            "11": 379,
            "12": 283,
            "13": 236,
            "14": 152,
            "15": 339,
            "16": 524,
            "17": 411,
            "18": 379,
            "19": 300,
            "20": 265,
            "21": 400,
            "22": 531,
            "23": 305,
            "24": 526,
            "25": 409,
            "26": 222,
            "28": 15,
            "01": 0,
            "02": 414,
            "03": 412,
            "04": 290,
            "05": 0,
            "06": 0,
            "07": 209,
            "08": 378,
            "09": 262
          }
        },
        {
          "HwId": "P15",
          "Label": "P Iso kuoppapäästöuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 121,
            "14": 115,
            "15": 125,
            "16": 87,
            "17": 0,
            "18": 0,
            "19": 104,
            "20": 134,
            "21": 134,
            "22": 129,
            "23": 93,
            "24": 0,
            "25": 0,
            "26": 80,
            "28": 5,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 63,
            "06": 0,
            "07": 136,
            "08": 44,
            "09": 0
          }
        },
        {
          "HwId": "P16",
          "Label": "P Päästöuuni 'Iso B'",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 74,
            "11": 0,
            "12": 277,
            "13": 303,
            "14": 106,
            "15": 0,
            "16": 84,
            "17": 91,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 267,
            "22": 0,
            "23": 383,
            "24": 0,
            "25": 0,
            "26": 373,
            "27": 414,
            "28": 337,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 472,
            "06": 0,
            "07": 0,
            "08": 304,
            "09": 219
          }
        },
        {
          "HwId": "P18",
          "Label": "P Ufo",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "28": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 172,
            "09": 0
          }
        },
        {
          "HwId": "P2",
          "Label": "P Ipsen T17",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 1451,
            "11": 1273,
            "12": 1170,
            "13": 1233,
            "14": 1606,
            "15": 832,
            "16": 141,
            "17": 1205,
            "18": 1088,
            "19": 1189,
            "20": 1433,
            "21": 1208,
            "22": 1352,
            "23": 1515,
            "24": 1271,
            "25": 669,
            "26": 1184,
            "27": 1158,
            "28": 1412,
            "01": 982,
            "02": 1367,
            "03": 1205,
            "04": 1212,
            "05": 1141,
            "06": 1415,
            "07": 1304,
            "08": 1244,
            "09": 1382
          }
        },
        {
          "HwId": "P20",
          "Label": "P Ipsen T17_1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 505,
            "11": 534,
            "12": 1405,
            "13": 1619,
            "14": 1278,
            "15": 549,
            "16": 164,
            "17": 1090,
            "18": 875,
            "19": 1137,
            "20": 1256,
            "21": 1466,
            "22": 1282,
            "23": 1203,
            "24": 1135,
            "25": 1110,
            "26": 1261,
            "27": 1134,
            "28": 1193,
            "01": 535,
            "02": 535,
            "03": 535,
            "04": 535,
            "05": 1115,
            "06": 912,
            "07": 1582,
            "08": 1566,
            "09": 692
          }
        },
        {
          "HwId": "P3",
          "Label": "P Heattec 1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 141,
            "11": 1,
            "12": 237,
            "13": 385,
            "14": 484,
            "15": 187,
            "16": 16,
            "17": 260,
            "18": 232,
            "19": 229,
            "20": 267,
            "21": 463,
            "22": 258,
            "23": 265,
            "24": 209,
            "25": 209,
            "26": 524,
            "27": 259,
            "28": 293,
            "01": 192,
            "02": 191,
            "03": 192,
            "04": 191,
            "05": 256,
            "06": 223,
            "07": 449,
            "08": 295,
            "09": 285
          }
        },
        {
          "HwId": "P4",
          "Label": "P Heattec 2",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 229,
            "11": 2,
            "12": 629,
            "13": 863,
            "14": 782,
            "15": 387,
            "16": 46,
            "17": 550,
            "18": 529,
            "19": 642,
            "20": 690,
            "21": 763,
            "22": 687,
            "23": 638,
            "24": 567,
            "25": 333,
            "26": 649,
            "27": 749,
            "28": 819,
            "01": 478,
            "02": 713,
            "03": 575,
            "04": 479,
            "05": 684,
            "06": 509,
            "07": 789,
            "08": 702,
            "09": 577
          }
        },
        {
          "HwId": "P5",
          "Label": "P Heattec 3",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 393,
            "11": 379,
            "12": 716,
            "13": 476,
            "14": 546,
            "15": 251,
            "16": 30,
            "17": 274,
            "18": 2,
            "19": 441,
            "20": 522,
            "21": 604,
            "22": 519,
            "23": 515,
            "24": 392,
            "25": 163,
            "26": 507,
            "27": 505,
            "28": 548,
            "01": 43,
            "02": 44,
            "03": 43,
            "04": 43,
            "05": 300,
            "06": 377,
            "07": 510,
            "08": 566,
            "09": 438
          }
        },
        {
          "HwId": "P6",
          "Label": "P Heattec 4",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 206,
            "11": 208,
            "12": 276,
            "13": 447,
            "14": 316,
            "15": 158,
            "16": 34,
            "17": 140,
            "18": 2,
            "19": 1,
            "20": 190,
            "21": 364,
            "22": 288,
            "23": 220,
            "24": 207,
            "25": 205,
            "26": 299,
            "27": 203,
            "28": 310,
            "01": 192,
            "02": 416,
            "03": 331,
            "04": 203,
            "05": 216,
            "06": 188,
            "07": 237,
            "08": 261,
            "09": 259
          }
        },
        {
          "HwId": "P7",
          "Label": "P Automaattilinjan pesukone",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 137,
            "11": 106,
            "12": 321,
            "13": 380,
            "14": 319,
            "15": 199,
            "16": 14,
            "17": 150,
            "18": 147,
            "19": 220,
            "20": 277,
            "21": 304,
            "22": 325,
            "23": 375,
            "24": 140,
            "25": 121,
            "26": 258,
            "27": 237,
            "28": 350,
            "01": 120,
            "02": 177,
            "03": 152,
            "04": 136,
            "05": 199,
            "06": 131,
            "07": 306,
            "08": 409,
            "09": 303
          }
        },
        {
          "HwId": "P8",
          "Label": "P Kompressori",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 16,
            "11": 17,
            "12": 16,
            "13": 17,
            "14": 16,
            "15": 10,
            "16": 2,
            "17": 16,
            "18": 17,
            "19": 16,
            "20": 17,
            "21": 17,
            "22": 16,
            "23": 17,
            "24": 16,
            "25": 17,
            "26": 17,
            "27": 16,
            "28": 17,
            "01": 17,
            "02": 16,
            "03": 17,
            "04": 16,
            "05": 17,
            "06": 16,
            "07": 17,
            "08": 16,
            "09": 17
          }
        },
        {
          "HwId": "P9",
          "Label": "P Jäähdytysjärjestelmä",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 201,
            "11": 184,
            "12": 216,
            "13": 227,
            "14": 229,
            "15": 122,
            "16": 16,
            "17": 179,
            "18": 175,
            "19": 160,
            "20": 178,
            "21": 176,
            "22": 174,
            "23": 176,
            "24": 164,
            "25": 168,
            "26": 182,
            "27": 190,
            "28": 213,
            "01": 141,
            "02": 153,
            "03": 152,
            "04": 154,
            "05": 171,
            "06": 199,
            "07": 207,
            "08": 238,
            "09": 231
          }
        }
      ]
    },
    "SiteId": "c16084",
    "EdgeUnitId": "os-edge-unit-mini-3"
  }
]